import axios from 'axios'
import * as auth from '../../services/auth'
import request from '../../services/request'

export const register = async ({ commit }, payload) => {
	console.log(commit);
	try {
		let { data } = await auth.register(payload)
		if (data) {
			return Promise.resolve(data)
		} else {
			return Promise.reject('error')
		}
	} catch (err) {
		return Promise.reject(err)
	}
}

export const login = async ({ commit }, payload) => {
	try {
		let { data } = await auth.login(payload)
		if (data ) {
			if (data.access_token) {
				commit('setUser', data.user);
				commit('setToken', data.access_token);
				return Promise.resolve(true)
			} else {
				return Promise.resolve(false)
			}
		} else {
			return Promise.reject(data)
		}
	} catch (err) {
		return Promise.reject(err)
	}
}

export const refreshToken = async ({ commit }) => {
	try {
		let { data } = await auth.refresh()

		if (data && data.access_token) {
			commit('setToken', data.access_token)
			axios.defaults.headers.common['Authorization'] = 'Bearer ' + data.access_token
			return true
		}

		return false
	} catch (err) {
		return false
	}
}

export const resetPass = async ({ commit }, payload) => {
	console.log(commit);
	try {
		let { data } = await request.post('/auth/reset-password-request', payload)
		return Promise.resolve(data)
	} catch (err) {
		return Promise.reject(err)
	}
}

export const changepass = async ({ commit }, payload) => {
	console.log(commit);
	try {
		let { data } = await request.post('/auth/change-password', payload)
		return Promise.resolve(data)
	} catch (err) {
		return Promise.reject(err)
	}
}

export const logout = async ({ commit }) => {
	try {
		await auth.logout()
	} catch (err) {
		console.log('No se pudo cerrar sesión en backend, se limpiará sesión local.', err)
	}

	commit('setUser', null)
	commit('setToken', null)
	delete axios.defaults.headers.common['Authorization']

	return true
}

export const getUser = async () => {
	try {
		let { data } = await auth.getUser()
		console.log(data)
		// commit('setUser', data)
		return Promise.resolve(true)
	} catch (err) {
		// commit('setUser', null)
		// commit('setToken', null)
		return Promise.reject(false)
	}
}

export const updateUser = async (payload) => {
	try {
		let { data } = await auth.updateUser(payload)
		console.log(data)
		// commit('setUser', data)
		return Promise.resolve(true)
	} catch (err) {
		// commit('setUser', null)
		// commit('setToken', null)
		return Promise.reject(false)
	}
}

